module.exports = __webpack_public_path__ + "bf80f4916bebb2f816b1291666d6c3b2.pdf";